'use strict';

import angular from 'angular';
import ModelController from './model.controller';

export default angular.module('updateServerApp.firmwares.model', [])
  .controller('FirmwaresModelController', ModelController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/model/index.js